const ENV = process.env

export default {
  customerInfo: ENV.REACT_APP_FEAT_CUSTOMER_INFO,
  accountInformation: ENV.REACT_APP_FEAT_ACCOUNT_INFORMATION,
  existingServices: ENV.REACT_APP_FEAT_EXISTING_SERVICES,
  navigation: ENV.REACT_APP_FEAT_NAVIGATION
}
